import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { useQuery } from 'glimmer-apollo';
import { REVIEWS_INDEX_OPTIMIZED_QUERY } from 'embroil/gql/queries/reviews-index-optimized';

export default class ReviewsIndexRoute extends Route {
  @service head;

  queryParams = {
    page: {
      refreshModel: true
    }
  };

  async model(params) {
    const page = parseInt(params.page) || 1;
    const limit = 10;
    const skip = (page - 1) * limit;

    // Set canonical URL and robots meta for pagination
    const baseUrl = 'https://1vx.gg/reviews';
    if (page > 1) {
      this.head.updateMeta({
        canonical: baseUrl,
        robots: 'noindex,follow'
      });
    } else {
      this.head.updateMeta({
        canonical: baseUrl,
        robots: ''
      });
    }

    const query = useQuery(this, () => [
      REVIEWS_INDEX_OPTIMIZED_QUERY,
      { variables: { limit, skip } }
    ]);

    try {
      await query.promise;
      const articlesData = query.data.articles || {};
      const total = articlesData.total || 0;

      return {
        articles: articlesData.items || [],
        pagination: {
          currentPage: page,
          totalCount: total,
          limit: limit,
          hasNextPage: skip + limit < total,
          hasPreviousPage: page > 1
        }
      };
    } catch (error) {
      console.error('Error loading reviews:', error);
      return {
        articles: [],
        pagination: {
          currentPage: 1,
          totalCount: 0,
          limit: limit,
          hasNextPage: false,
          hasPreviousPage: false
        }
      };
    }
  }
}
